import React, { useEffect, useState } from "react";
import { sanity, videoAssetFor } from "../client.js";
import styled from "styled-components";

const Motion = () => {
	const [motionData, setMotionData] = useState(null);
	useEffect(() => {
		sanity
			.fetch(
				`*[_type == "interactiveMotion"]{
			title,
			description,
			thumbnail,
			link,
			videoAnimation,
		}`
			)
			.then((data) => {
				setMotionData(data);
			})
			.catch(console.error);
	}, []);

	return (
		<Wrapper>
			<StyledHeading
				data-aos="fade-up"
				data-aos-delay="50"
				data-aos-duration="1000"
				data-aos-easing="ease-in-out"
			>
				<h2 className="Heading">
					Interaction <br /> & Motion
				</h2>
				<img
					src="./images/Sphere-Blue-Glossy.png"
					alt=""
					className="sphere"
				/>
				<img src="./images/SuperToroid.png" alt="" className="donut" />
			</StyledHeading>
			<main>
				{motionData &&
					motionData.map((brand, index) => (
						<Card
							className="card"
							key={index}
							data-aos="fade-up"
							data-aos-offset="100"
							data-aos-delay="50"
							data-aos-duration="1000"
							data-aos-easing="ease-in-out"
						>
							<div className="card-image">
								{brand.videoAnimation ? (
									<video
										width="508"
										height="818"
										controls
										autoPlay
									>
										<source
											src={
												videoAssetFor(
													brand.videoAnimation
														.projectVideo
												).url
											}
											type="video/mp4"
										/>
									</video>
								) : (
									" "
								)}
							</div>
							<div className="card-info">
								<div className="card-info-right">
									<h3 className="card-title">
										{brand.title}
									</h3>
									<p className="card-description">
										{brand.description}
									</p>
								</div>
							</div>
						</Card>
					))}
			</main>
			<section className="additional-footer">
				<div>
					<span className="dash"></span>More on Interaction & Motion
					<span className="dash"></span>
				</div>
			</section>
		</Wrapper>
	);
};
export default Motion;

const Wrapper = styled.div`
	max-width: 500px;
	margin: 0 auto;
	padding: 0 16px;
	@media (max-width: 400px) {
		overflow: hidden;
	}
	@media (min-width: 1000px) {
		max-width: 850px;
	}

	.additional-footer {
		padding-bottom: 64px;

		& > div {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 8px;
		}
		.dash {
			display: block;
			height: 1px;
			width: 50px;
			background-color: black;

			@media (min-width: 750px) {
				width: 100px;
			}
		}

`;
const StyledHeading = styled.div`
	font-family: AxiformaBold;
	text-transform: uppercase;
	font-size: 1.5rem;
	position: relative;
	width: max-content;
	padding-top: 160px;
	margin-bottom: 90px;
	& img {
		width: 80px;
		position: absolute;
		z-index: -1;
	}

	.donut {
		top: 120px;
		left: -20px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(10px);
			}
		}
		& {
			animation: bounce 1.3s infinite alternate;
		}
	}

	.sphere {
		right: -30px;
		bottom: -35px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-12px);
			}
		}
		& {
			animation: bounce 1.4s infinite alternate;
		}
	}

	@media (min-width: 750px) {
		.donut {
			left: -60px;
			top: 120px;
		}

		.sphere {
			right: -20px;
			bottom: -20px;
		}
	}
`;
const Card = styled.div`
	margin: 48px 0;

	@media (min-width: 1000px) {
		margin: 128px 0;
	}
	.card-info {
		display: grid;
		grid-template-columns: 5fr 1fr;
		margin-top: 16px;
	}

	.card-image {
		video {
			height: 100%;
			width: 100%;
		}
	}
	.card-title {
		font-family: AxiformaBold;
		font-size: 2.5rem;
		text-transform: capitalize;
		font-weight: 500;
	}

	.card-description {
		margin-right: 8px;

		@media (min-width: 1000px) {
			width: 55%;
			font-size: 0.8rem;
		}
	}

	.right-arrow-content {
		border: 1px solid grey;
		border-radius: 50%;
		display: grid;
		place-content: center;
		height: 50px;
		width: 50px;
		align-self: center;
		justify-self: end;
	}

	@media (min-width: 650px) {
		.card-info {
			display: grid;
			grid-template-columns: 5fr 1fr;
			margin-top: 32px;
		}

		.card-title {
			font-family: AxiformaBold;
			font-size: 2.5rem;
			text-transform: capitalize;
			font-weight: 500;
		}

		.card-description {
			max-width: 70%;
		}

		.right-arrow-content {
			margin-top: 32px;
			border: 1px solid grey;
			border-radius: 50%;
			display: grid;
			place-content: center;
			height: 50px;
			width: 50px;
			justify-self: end;
		}
	}
`;
